import { render, staticRenderFns } from "./AnswerExamUserDetail.vue?vue&type=template&id=9899178c&scoped=true"
import script from "./AnswerExamUserDetail.vue?vue&type=script&lang=js"
export * from "./AnswerExamUserDetail.vue?vue&type=script&lang=js"
import style0 from "./AnswerExamUserDetail.vue?vue&type=style&index=0&id=9899178c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9899178c",
  null
  
)

export default component.exports